import { Section, SectionContainer } from '@components/Section';
import Styles from './FaqSection.module.scss';
import Accordion from '@hiredigital/ui/Accordion/Accordion';
import DefaultFaq from './DefaultFaq';

const FaqSection = ({ data, title, ...props }) => {
  const faqs = (!!data?.length ? data : DefaultFaq).map(({ question: q, answer: a }) => ({
    title: q,
    content: a?.html || a?.text || a,
  }));
  return (
    <SectionContainer type={SectionContainer.Type.LIGHTBLUE} className={Styles.container}>
      <Section title={title || `Frequently Asked Questions`} {...props}>
        <Accordion data={faqs} />
      </Section>
    </SectionContainer>
  );
};
export default FaqSection;
